import { render, staticRenderFns } from "./CollectionButtons.vue?vue&type=template&id=568682f8&"
import script from "./CollectionButtons.vue?vue&type=script&lang=js&"
export * from "./CollectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568682f8')) {
      api.createRecord('568682f8', component.options)
    } else {
      api.reload('568682f8', component.options)
    }
    module.hot.accept("./CollectionButtons.vue?vue&type=template&id=568682f8&", function () {
      api.rerender('568682f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/Collection/CollectionButtons.vue"
export default component.exports